<template>
  <div class="billing-address-form">
    <div class="payment-card">
      <div class="payment-card__header">
        <div class="payment-card__title">Fatura Adresi</div>
      </div>
      <div class="payment-card__content">
        <div class="address-info">
          <div class="address-item full-width">
            <div class="billing-type-container">
              <span class="billing-type-label">Fatura Türü:</span>
              <a-switch
                v-model="form.isCompany"
                checked-children="Şirket"
                un-checked-children="Bireysel"
                class="billing-type-switch"
              />
            </div>
          </div>

          <div class="address-columns">
            <div class="address-item" v-if="form.isCompany" :class="{ 'has-error': errors.companyName }">
              <a-icon type="shop" />
              <a-input
                v-model="form.companyName"
                @input="handleInput('companyName')"
                data-field="companyName"
                class="edit-input"
                placeholder="Şirket Adı*"
              />
            </div>
            <div class="address-item" v-else :class="{ 'has-error': errors.fullName }">
              <a-icon type="user" />
              <a-input
                v-model="form.fullName"
                @input="handleInput('fullName')"
                data-field="fullName"
                class="edit-input"
                placeholder="Ad Soyad*"
              />
            </div>
            <div class="address-item" :class="{ 'has-error': errors.email }">
              <a-icon type="mail" />
              <a-input
                v-model="form.email"
                @input="handleInput('email')"
                data-field="email"
                class="edit-input"
                type="email"
                placeholder="E-Posta*"
              />
            </div>
          </div>

          <div class="address-columns">
            <div class="address-item" v-if="!form.isCompany" :class="{ 'has-error': errors.identityNumber }">
              <a-icon type="idcard" />
              <a-input
                v-model="form.identityNumber"
                @input="handleInput('identityNumber')"
                data-field="identityNumber"
                class="edit-input"
                placeholder="TC Kimlik Numarası*"
              />
            </div>
            <div class="address-item" v-if="form.isCompany" :class="{ 'has-error': errors.taxNumber }">
              <a-icon type="number" />
              <a-input
                v-model="form.taxNumber"
                @input="handleInput('taxNumber')"
                data-field="taxNumber"
                class="edit-input"
                placeholder="Vergi Numarası*"
              />
            </div>
            <div class="address-item" v-if="form.isCompany" :class="{ 'has-error': errors.taxOffice }">
              <a-icon type="audit" />
              <a-input
                v-model="form.taxOffice"
                @input="handleInput('taxOffice')"
                data-field="taxOffice"
                class="edit-input"
                placeholder="Vergi Dairesi*"
              />
            </div>
          </div>

          <div class="address-columns">
            <div class="address-item" :class="{ 'has-error': errors.billingCountry }">
              <a-icon type="global" />
              <a-input
                v-model="form.billingCountry"
                @input="handleInput('billingCountry')"
                data-field="billingCountry"
                class="edit-input"
                placeholder="Ülke*"
              />
            </div>
            <div class="address-item" :class="{ 'has-error': errors.billingCity }">
              <a-icon type="environment" />
              <a-input
                v-model="form.billingCity"
                @input="handleInput('billingCity')"
                data-field="billingCity"
                class="edit-input"
                placeholder="Şehir*"
              />
            </div>
          </div>

          <div class="address-item flex-start-item full-width" :class="{ 'has-error': errors.billingAddress }">
            <a-icon type="home" />
            <a-textarea
              v-model="form.billingAddress"
              @input="handleInput('billingAddress')"
              data-field="billingAddress"
              class="edit-input"
              placeholder="Tam Adres*"
              :rows="3"
            />
          </div>
        </div>
      </div>
    </div>
    
    <div class="modal-footer">
      <SupsisButton ghost @click="$emit('cancel')">İptal</SupsisButton>
      <SupsisButton primary @click="submitForm">Devam Et</SupsisButton>
    </div>
  </div>
</template>

<script>
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";

export default {
  name: "BillingAddressForm",
  components: {
    SupsisButton
  },
  props: {
    initialValues: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        isCompany: false,
        companyName: "",
        fullName: "",
        email: "",
        identityNumber: "",
        taxNumber: "",
        taxOffice: "",
        billingCountry: "Türkiye",
        billingCity: "",
        billingAddress: ""
      },
      errors: {}
    };
  },
  created() {
    if (this.initialValues) {
      this.form = { ...this.form, ...this.initialValues };
    }
  },
  methods: {
    handleInput(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field);
      }
    },
    validateForm() {
      this.errors = {};
      let isValid = true;
      
      // Şirket veya bireysel bilgisi doğrulama
      if (this.form.isCompany) {
        if (!this.form.companyName) {
          this.errors.companyName = true;
          isValid = false;
        }
        if (!this.form.taxNumber) {
          this.errors.taxNumber = true;
          isValid = false;
        }
        if (!this.form.taxOffice) {
          this.errors.taxOffice = true;
          isValid = false;
        }
      } else {
        if (!this.form.fullName || this.form.fullName.trim().split(' ').length < 2) {
          this.errors.fullName = true;
          isValid = false;
        }
        if (!this.form.identityNumber || this.form.identityNumber.length !== 11) {
          this.errors.identityNumber = true;
          isValid = false;
        }
      }
      
      // Email doğrulama
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.form.email || !emailRegex.test(this.form.email)) {
        this.errors.email = true;
        isValid = false;
      }
      
      // Adres bilgilerini doğrulama
      if (!this.form.billingCountry) {
        this.errors.billingCountry = true;
        isValid = false;
      }
      
      if (!this.form.billingCity) {
        this.errors.billingCity = true;
        isValid = false;
      }
      
      if (!this.form.billingAddress || this.form.billingAddress.length < 10) {
        this.errors.billingAddress = true;
        isValid = false;
      }
      
      if (!isValid) {
        this.$message.error("Lütfen zorunlu alanları doldurunuz");
        return false;
      }
      
      return true;
    },
    submitForm() {
      if (this.validateForm()) {
        let formattedData = {
          ...this.form,
          billingType: this.form.isCompany ? "company" : "individual"
        };
        
        if (this.form.isCompany) {
          formattedData.name = this.form.companyName;
          formattedData.surname = "";
        } else {
          const nameParts = this.form.fullName.trim().split(/\s+/);
          formattedData.name = nameParts[0];
          formattedData.surname = nameParts.slice(1).join(' ');
        }
        
        this.$emit('submit', formattedData);
      }
    }
  }
};
</script>

<style scoped>
.payment-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 10px;
  border: 1px solid #e8e8e8;
  transition: box-shadow 0.3s;
}

.payment-card__header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #edf2f7;
}

.payment-card__title {
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
  letter-spacing: -0.2px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.payment-card__title::before {
  content: "";
  display: block;
  width: 3px;
  height: 20px;
  background: #2f54eb;
  border-radius: 2px;
}

.payment-card__content {
  padding: 16px 0;
}

.address-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.address-columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.address-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f8fafc;
  border-radius: 6px;
}

.address-item.flex-start-item {
  align-items: flex-start;
}

.full-width {
  grid-column: 1 / -1;
}

.edit-input {
  background: #f8fafc;
  border: none;
  box-shadow: none;
  padding: 0 8px;
  flex: 1;
}

.edit-input:focus {
  box-shadow: 0 0 0 2px rgba(47, 84, 235, 0.2);
}

.edit-input::placeholder {
  color: #a0aec0;
  font-style: italic;
}

.address-item .anticon {
  margin-right: 12px;
  color: #667eea;
  flex-shrink: 0;
}

.billing-type-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 0;
}

.billing-type-label {
  font-weight: 500;
  color: #2d3748;
}

.billing-type-switch {
  background-color: #e2e8f0;
}

.billing-type-switch.ant-switch-checked {
  background-color: #2f54eb;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #edf2f7;
}

.has-error {
  .edit-input,
  .ant-input {
    border: 1px solid #ff4d4f !important;
    background-color: #fff1f0 !important;
  }

  .anticon {
    color: #ff4d4f !important;
  }
}
</style> 